import React from 'react';
import { Link } from 'react-router-dom';
import env from '../../../env';
import { Loading, ErrorPopup, usePost } from '../../../components';
import utils from '../../../utils';
import './dartfishList.css';

/** productType 5 = Dartfish */
const DARTFISH_PRODUCT_TYPE = 5;

export function DartfishListView(props) {
  const { item, cmsOption } = props;
  const post = usePost();

  React.useEffect(() => {
    post.send(env.apiBase + '/api/product/getProducts', { productType: DARTFISH_PRODUCT_TYPE });
    // eslint-disable-next-line
  }, []);

  if (post.loading()) {
    return <Loading />;
  }
  if (post.hasErrors()) {
    return <ErrorPopup title="Loading Error" errors={post.errors} />;
  }

  const data = post.response;
  const items = (data && (data.items || data.Items)) || [];

  return (
    <div className="cms_item dartfishList" data-cms-item-id={cmsOption?.isCmsEdit && item?.itemId} id={item?.anchorName}>
      <DartfishProducts items={items} />
    </div>
  );
}

function DartfishProducts({ items = [] }) {
  if (items.length === 0) {
    return <div className="dartfishList__empty">No Dartfish products available at this time.</div>;
  }

  return (
    <div className="dartfishList__grid">
      {items.map((product) => {
        const productId = (product.productId || product.ProductId)?.toString();
        const productUrl = product.productUrl ? product.productUrl : `/product/${product.productSlug}`;
        const name = product.productName || product.ProductName || 'Dartfish Product';
        const rawImage = product.thumbnailUrl || product.ThumbnailUrl || product.imageUrl || product.ImageUrl;
        const imageUrl = rawImage
          ? (rawImage.startsWith('http') ? rawImage : utils.site.resourcePath(rawImage))
          : null;
        const priceNum = Number(product.priceIncTax || product.PriceIncTax || product.price || product.Price);
        const priceText = Number.isFinite(priceNum) && priceNum > 0
          ? `AU $${priceNum.toFixed(2)}`
          : 'Contact us';
        const checkoutUrl = productId
          ? `/checkout/dartfish?productId=${encodeURIComponent(productId)}`
          : productUrl;

        return (
          <div key={productId} className="dartfishList__card">
            {imageUrl && (
              <div className="dartfishList__cardImage">
                <img src={imageUrl} alt={name} loading="lazy" />
              </div>
            )}
            <div className="dartfishList__cardBody">
              <h3 className="dartfishList__cardTitle">{name}</h3>
              {product.shortDesc && (
                <p className="dartfishList__cardDesc">{product.shortDesc}</p>
              )}
              <div className="dartfishList__cardFooter">
                <span className="dartfishList__cardPrice">{priceText}</span>
                <Link to={checkoutUrl} className="dartfishList__cardBtn">Register Now</Link>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
